/* eslint-disable jsx-quotes */
import React, { Component } from 'react';

import Paginator from '../Paginator';
import ItemOptionSelectQuestion from './ItemOptionSelectQuestion';

import './selection-questions.css';

class SelectQuestionsPresentation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            total,
            limit,
            onChangePage,
            onChangeRowsPerPage,
            questions,
            questionsAddeds,
            handleQuestionsAddeds,
            checkDisableQuestionFn,
        } = this.props;
        return (
            <section className="content-questions">
                {questions &&
                    questions.map(question => (
                        <ItemOptionSelectQuestion
                            checkDisableQuestionFn={checkDisableQuestionFn}
                            onChangeSelect={handleQuestionsAddeds}
                            checked={questionsAddeds.includes(question.id)}
                            key={question.id}
                            question={question}
                        />
                    ))}
                <Paginator
                    totalRows={total}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    rowsPerPage={Number(limit)}
                />
            </section>
        );
    }
}

export default SelectQuestionsPresentation;



// WEBPACK FOOTER //
// ./src/components/selection-questions/selection-questions-presentation.js